import medium from './medium printout.JPG'

const Blogs = [
    {
        id: 1,
        name: 'Deploying my first project on Vercel',
        description: 'This talks about to deploy your Nextjs first project on Vercel',
        image: medium,
        link: 'https://www.google.com'
    },

]

export default Blogs;